import { render, staticRenderFns } from "./StatementRail.vue?vue&type=template&id=2ae9ca2e&scoped=true"
import script from "./StatementRail.vue?vue&type=script&lang=js"
export * from "./StatementRail.vue?vue&type=script&lang=js"
import style0 from "./StatementRail.vue?vue&type=style&index=0&id=2ae9ca2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae9ca2e",
  null
  
)

export default component.exports